// extracted by mini-css-extract-plugin
export default {"container":"adDetailInfo_container__5LP15","line":"adDetailInfo_line__lKh4N","contentContainer":"adDetailInfo_contentContainer__7F7N0"};